import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./LoginScreen.css";

const LoginScreen = ({ onLogin }) => {
  return (
    <Container
      fluid
      className="login-screen d-flex align-items-center justify-content-center"
    >
      <Row className="w-100 justify-content-center">
        <Col xs={12} md={8} lg={6}>
          <Card className="shadow login-card">
            <Card.Body className="p-4 p-md-5">
              <Card.Title className="mb-3 text-center fs-3">
                Cohorz ToDo Appへようこそ
              </Card.Title>
              <Card.Text className="text-muted text-center mb-4">
                ローカル環境でのみデータを保存します。
                <br />
                ログインすると、保存したタスクやタグをすぐに利用できます。
              </Card.Text>
              <div className="login-feature-list mb-4">
                <div>
                  <i className="bi bi-check-circle text-success me-2"></i>
                  端末のローカルストレージにデータを保存します
                </div>
                <div>
                  <i className="bi bi-check-circle text-success me-2"></i>
                  いつでもサインアウトしてログイン画面に戻れます
                </div>
                <div>
                  <i className="bi bi-check-circle text-success me-2"></i>
                  将来のクラウド連携にも対応予定です
                </div>
              </div>
              <div className="d-grid gap-2">
                <Button variant="primary" size="lg" onClick={onLogin}>
                  <i className="bi bi-person-check me-2"></i>
                  ローカルログイン
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginScreen;
